import { BaseDto } from './base.dto';
import { ProductMenuModifierDto } from './productMenuModifier.dto';

export class BundleMenuCategoryItemDto extends BaseDto {
  id: number;
  startDate: Date;
  endDate: Date;
  product: ProductMenuModifierDto;
}
